type Props = { className?: string };
export const WordIcon = ({ className }: Props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      className={className}
      viewBox="0 0 48 48">
      <defs>
        <linearGradient
          id="yURKxjsGzuO2sJnz7bo6Na_vCmmOWVBAcll_gr1"
          x1="25"
          x2="42"
          y1="24"
          y2="24"
          gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#33bef0"></stop>
          <stop offset="1" stopColor="#22a5e2"></stop>
        </linearGradient>
        <linearGradient
          id="yURKxjsGzuO2sJnz7bo6Nb_vCmmOWVBAcll_gr2"
          x1="29.53"
          x2="4.68"
          y1="24"
          y2="24"
          gradientUnits="userSpaceOnUse">
          <stop offset=".11" stopColor="#0d62ab"></stop>
          <stop offset="1" stopColor="#007ad9"></stop>
        </linearGradient>
      </defs>
      <path
        fill="url(#yURKxjsGzuO2sJnz7bo6Na_vCmmOWVBAcll_gr1)"
        d="m41,10h-16v28h16c.55,0,1-.45,1-1V11c0-.55-.45-1-1-1Z"></path>
      <path
        fill="#fff"
        d="m25,15h14v2h-14v-2Zm0,4h14v2h-14v-2Zm0,4h14v2h-14v-2Zm0,4h14v2h-14v-2Zm0,4h14v2h-14v-2Z"></path>
      <path
        fill="url(#yURKxjsGzuO2sJnz7bo6Nb_vCmmOWVBAcll_gr2)"
        d="m27,42l-21-4V10l21-4v36Z"></path>
      <path
        fill="#fff"
        d="m21.17,31.01h-2.72l-1.8-8.99c-.1-.48-.16-1-.17-1.58h-.03c-.04.64-.11,1.16-.2,1.58l-1.85,8.99h-2.83l-2.86-14.01h2.68l1.54,9.33c.06.4.11.94.14,1.61h.04c.02-.5.1-1.05.22-1.65l1.97-9.29h2.62l1.78,9.4c.06.35.12.85.17,1.51h.03c.02-.51.07-1.03.16-1.56l1.5-9.35h2.47l-2.87,14.02Z"></path>
    </svg>
  );
};
